import React, { useContext } from 'react';
import styles from './styles.module.scss';
// import AppImage from '../AppImage';
// import { useRouter } from 'next/router';
// import Api from '@/api';
import Api from '../../api';

import Cookies from 'js-cookie';

// import { AdminContext } from '@/context/AdminContext';
// import CheckToken from '@/functions/CheckToken';
// import AppImage from '../AppImage';
import CheckToken from '../../functions/CheckToken';
import { AdminContext } from '../../context/AdminContext';
import CookieFunction from '../../functions/cookieFunction';
// import { AdminContext } from '../../context/AdminContext';

const SignUpSuccess = ({
  setSignUpModal,
  setShowModal,
  loginInformation,
  setLoginInformation,
}) => {
  const { setTrigger, login, content } = useContext(AdminContext);
  // const router = useRouter();

  return (
    <div
      className={`flex flex-col justify-center items-center w-full h-auto ${styles.successPadding} pb-2 my-auto`}
    >
      {/* <AppImage
        src="/imgs/login/checkCircle.svg"
        alt="checked"
        width={100}
        height={100}
      /> */}
      <p className={styles.text}>{content?.signup?.success?.title} </p>
      <p className={styles.text}>{content?.signup?.success?.description}</p>

      <button
        className={`${styles.submitItem} ${styles.upload} mainBg`}
        onClick={() => {
          window?.location?.reload();
          CookieFunction(
            'set',
            'ochattToken',
            loginInformation.data.response.accessToken
            // () => {
            //   setLogin(CookieFunction('get', 'ochattToken'));
            // }
          );
          CookieFunction(
            'set',
            'userAuthOchatt',
            loginInformation.data.response.uuid
          );
          CookieFunction(
            'set',
            'userAuthOchattId',
            loginInformation.data.response.channelId
          );

          // Cookies.set('ochattToken', res.data.response.accessToken, {
          //   expires: 365,
          // });
          // Cookies.set('userAuthOchatt', res.data.response.channelId, {
          //   expires: 365,
          // });

          // setLogin(Cookies.get('ochattToken'));
          // Cookies.remove('fromSignUp');
          // Cookies.set('user', res.data.response.id, {
          //   expires: 365,
          // });

          CookieFunction('set', 'user', loginInformation.data.response.id);
          setLoginInformation();
        }}
      >
        <span>{content?.signup?.success?.button}</span>
      </button>
    </div>
  );
};

export default SignUpSuccess;
